var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader4ShapeB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Asset 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2-2",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M1911.6 883.19l8.4-1.28V0H0v504.58l15.13-9.53A549 549 0 01119.23 427s121.26-60.77 281.65-60.35c24.57.06 45.82 2 48.62 2.21a552.56 552.56 0 01109 21.46c47.52 14.27 95.26 34.85 146 62.94C834.86 525.44 963.42 634 980.73 648.07c24.18 19.63 221.13 176.8 457.62 237.94 93.59 24.19 256.54 49.67 473.25-2.82z",
    fill: "#fff"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7b3BhY2l0eTowLjI1O30uY2xzLTJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQXNzZXRfMyIgZGF0YS1uYW1lPSJBc3NldCAzIiBjbGFzcz0iY2xzLTEiPjxnIGlkPSJMYXllcl8yLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMi0yIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEtMiI+PHBhdGggaWQ9IlBhdGhfNDUiIGRhdGEtbmFtZT0iUGF0aCA0NSIgY2xhc3M9ImNscy0yIiBkPSJNMTkxMS42LDg4My4xOWw4LjQtMS4yOFYwSDBWNTA0LjU4bDE1LjEzLTkuNTNBNTQ5LDU0OSwwLDAsMSwxMTkuMjMsNDI3czEyMS4yNi02MC43NywyODEuNjUtNjAuMzVjMjQuNTcuMDYsNDUuODIsMiw0OC42MiwyLjIxYTU1Mi41Niw1NTIuNTYsMCwwLDEsMTA5LDIxLjQ2YzQ3LjUyLDE0LjI3LDk1LjI2LDM0Ljg1LDE0Niw2Mi45NEM4MzQuODYsNTI1LjQ0LDk2My40Miw2MzQsOTgwLjczLDY0OC4wN2MyNC4xOCwxOS42MywyMjEuMTMsMTc2LjgsNDU3LjYyLDIzNy45NEMxNTMxLjk0LDkxMC4yLDE2OTQuODksOTM1LjY4LDE5MTEuNiw4ODMuMTlaIi8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgHeader4ShapeB as ReactComponent };